import React, { useState } from "react";
import { Outlet } from "react-router-dom";
import SideBar from "../SideBar";

const Layout = () => {
  return (
    <div className="side_panal">
      <div className="d-flex" style={{ width: "100vw" }}>
        <SideBar />
        <div className="rightView">
          <Outlet />
        </div>
      </div>
    </div>
  );
};

export default Layout;
